import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/transfer-statements/list/index.html';

const links: Record<string, string> = {
  account: '/infoTrac/transfer-statements/account-statements',
};

function AccountsList() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const account = iframeDocument.getElementsByClassName('selectAccountFromList');

      if (account.length) {
        for (let i = 0; i < account.length; i++) {
          account[i].addEventListener('click', () => navigate(links.account));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="transfer-statements-list"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="700px"
    />
  );
}

export default AccountsList;
